/*
 * Adds the discounted subscription price (with original price struck through)
 * next to each "Subscribe & Save" label, reading the price data the
 * Shopify Subscriptions app already embeds as JSON <script> tags.
 */
(function () {
  var target = document.querySelector('.subscriptions_app_embed_block');
  if (!target) {
    return;
  }

  function parseMoneyJSON(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function insertPriceInfo(label, data) {
    var info = document.createElement('span');
    info.className = 'subscribe-price-info';

    if (data.comparedAtPrice && data.comparedAtPrice !== data.price) {
      var compare = document.createElement('s');
      compare.className = 'subscribe-price-compare';
      compare.textContent = data.comparedAtPrice;
      info.appendChild(compare);
      info.appendChild(document.createTextNode(' '));
    }

    var sale = document.createElement('span');
    sale.className = 'subscribe-price-sale';
    sale.textContent = data.price;
    info.appendChild(sale);

    label.appendChild(info);
  }

  function enhanceSellingPlanLabel(labelWrap) {
    if (labelWrap.querySelector('.subscribe-price-info')) {
      return;
    }

    var childrenWrap = labelWrap.querySelector('.shopify_subscriptions_app_block_label_children');
    if (!childrenWrap) {
      return;
    }

    var jsonScript = childrenWrap.querySelector('script[type="application/json"]');
    if (!jsonScript) {
      return;
    }

    var data = parseMoneyJSON(jsonScript);
    if (!data || !data.price) {
      return;
    }

    var label = labelWrap.querySelector('label');
    if (!label) {
      return;
    }

    insertPriceInfo(label, data);
  }

  function enhanceOneTimePurchaseLabel(labelWrap) {
    if (labelWrap.querySelector('.subscribe-price-info')) {
      return;
    }

    // The one-time purchase price is a sibling <script>, not nested inside the label.
    var jsonScript = labelWrap.nextElementSibling;
    if (!jsonScript || jsonScript.tagName !== 'SCRIPT' || jsonScript.id.indexOf('subscriptions_money_with_currency_one_time_purchase_') !== 0) {
      return;
    }

    var data = parseMoneyJSON(jsonScript);
    if (!data || !data.price) {
      return;
    }

    var label = labelWrap.querySelector('label');
    if (!label) {
      return;
    }

    insertPriceInfo(label, data);
  }

  function enhanceAll() {
    var labels = target.querySelectorAll('.shopify_subscriptions_app_block_label');
    Array.prototype.forEach.call(labels, function (labelWrap) {
      if (labelWrap.querySelector('input[data-radio-type="selling_plan_group"]')) {
        enhanceSellingPlanLabel(labelWrap);
      } else if (labelWrap.querySelector('input[data-radio-type="one_time_purchase"]')) {
        enhanceOneTimePurchaseLabel(labelWrap);
      }
    });
  }

  // The app embeds one blank "selling_plan" hidden input per variant section on top of
  // the theme's own one, so the form always submits duplicate values for that field name.
  // Only the first one (kept in sync by the app's own script) should actually be submitted.
  function dedupeSellingPlanInputs() {
    var form = target.closest('form');
    if (!form) {
      return;
    }

    var inputs = form.querySelectorAll('.selected-selling-plan-id[name="selling_plan"]');
    Array.prototype.forEach.call(inputs, function (input, index) {
      if (index > 0) {
        input.removeAttribute('name');
      }
    });
  }

  function run() {
    enhanceAll();
    dedupeSellingPlanInputs();
  }

  run();

  // The app renders/reveals its markup asynchronously, so keep watching for it.
  var observer = new MutationObserver(run);
  observer.observe(target, { childList: true, subtree: true });
})();
